import { render, staticRenderFns } from "./o-icon.vue?vue&type=template&id=5eaba412&scoped=true&"
import script from "./o-icon.vue?vue&type=script&lang=js&"
export * from "./o-icon.vue?vue&type=script&lang=js&"
import style0 from "./o-icon.vue?vue&type=style&index=0&id=5eaba412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaba412",
  null
  
)

export default component.exports